import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const JournalService = {};

JournalService.getJournal = async function (groupId) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/journal/get-group`,
        params: {
            id: groupId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.getJournals = async function (page, limit, categoryId) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/journal/get`,
        params: {
            page: page - 1,
            limit: limit,
            categoryId: categoryId === undefined ? null : categoryId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

JournalService.getTopics = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/group/get-topics`,
        params: {
            id: id
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.saveLesson = async (topic, date) => {
    let data = new FormData();
    data.append("topic", topic);
    data.append("date", date);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/journal/lesson/save",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.updateLesson = async (id, date, journal_id, name) => {
    let data = new FormData();
    data.append("id", id);
    if (date === undefined) {
        data.append("isDone", true);
    } else {
        data.append("date", date);
    }
    if (name !== undefined && journal_id !== undefined) {
        data.append("name", name);
        data.append("journal_id", journal_id);
    }

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/journal/lesson/update",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.saveAttendances = async (attendances) => {
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/journal/attendance/save",
        data: attendances,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.makeAbsentForReason = async (id, reason) => {
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/journal/attendance/reason",
        params: {
            id: id,
            reason: reason
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.finishAllLessons = async (id) => {
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/journal/finish-all-lessons",
        params: {
            id: id
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.saveGrades = async (grades) => {
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/journal/grades/save",
        data: grades,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.saveLessonsToJournal = async (id, lessonRequest) => {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/journal/${id}/lesson/save`,
        data: lessonRequest,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

JournalService.importLessonsByExcel = async (id, file) => {
    let data = new FormData();
    data.append("file", file);
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/journal/${id}/lessons/excel/save`,
        data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default JournalService;